/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rahul's Portfolio",
  description:
    "Passionate Innovator Dedicated to Building Sustainable, Scalable Social and Technical Solutions with End-to-End Impact.",
  og: {
    title: "Rahul Bhandari Portfolio",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Rahul Bhandari",
  logo_name: "Rahul Bhandari",
  subTitle:
    "Passionate Innovator Dedicated to Building Sustainable, Scalable Social and Technical Solutions with End-to-End Impact",
  resumeLink:
    "https://drive.google.com/file/d/14inUhud49BrzdgI7a4O0SJ5R547SqCQR/view?usp=drivesdk",
  // portfolio_repository: "https://github.com/rahul-0000-code",
  githubProfile: "https://github.com/rahul-0000-code",
};

const socialMediaLinks = [{
  /* Your Social Media Link */
  github: "https://github.com/rahul-0000-code",
  linkedin: "https://www.linkedin.com/in/rahul-bhandari27/",
  gmail: "rahulkbhandari272002@gmail.com",
  facebook: "https://www.facebook.com/rahul.bhandari.9404362",
  instagram: "https://www.instagram.com/r.a.h.u.l_bhandari/"
},
  {
    name: "Github",
    link: "https://github.com/rahul-0000-code",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rahul-bhandari27/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "rahulkbhandari27200@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

  {
    name: "Facebook",
    link: "https://www.facebook.com/rahul.bhandari.9404362",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/r.a.h.u.l_bhandari/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Artificial Intelligence",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Crafting Scalable, Production-Ready Models for Advanced Deep Learning and Statistical Applications",
        "⚡ Getting experience through personal projects",
        "⚡ Efficient use of Open Source Models",
      ],
      softwareSkills: [
        {
          skillName: "GoogleColab",
          fontAwesomeClassname: "logos:jupyter",
          style: {
            backgroundColor: "transparent",
          },
        },

        {
          skillName: "LLM",
          fontAwesomeClassname: "logos:mistral-ai-icon",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        // {
        //   skillName: "PyTorch",
        //   fontAwesomeClassname: "logos-pytorch",
        //   style: {
        //     backgroundColor: "transparent",
        //   },
        // },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Developer",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing Dynamic Websites for Optimal User Engagement",
        "⚡ Creating product level websites as apart of interest",
        "⚡ Creating responsive and attractive web designs using Full Stack",
      ],
      softwareSkills: [
        {
          skillName: "NODEJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "NESTJS",
          fontAwesomeClassname: "logos:nestjs",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "DOCKER",
          fontAwesomeClassname: "skill-icons:docker",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "ri:nextjs-fill",
          style: {
            backgroundColor: "#000000",
            color: "#1572B6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "skill-icons:redis-light",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Grafana",
          fontAwesomeClassname: "logos:grafana",
          style: {
            backgroundColor: "#000000",
            color: "#fffff",
          },
        }
      ],
    },
    {
      title: "Software Skills",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple languages",
        "⚡ Creating projects and working on real time projects",
        "⚡ Implementing DSA and OOPs concept in varoius software developing stages",
        "⚡ Creating solution based softwares",
      ],
      softwareSkills: [
        {
          skillName: "C/C++",
          fontAwesomeClassname: "gg:c-plus-plus",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Java and JavaFrameworks",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "flat-color-icons:linux",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        // {
        //   skillName: "Kubernetes",
        //   fontAwesomeClassname: "simple-icons:kubernetes",
        //   style: {
        //     color: "#326CE5",
        //   },
        // },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        // {
        //   skillName: "Adobe XD",
        //   fontAwesomeClassname: "simple-icons:adobexd",
        //   style: {
        //     color: "#FF2BC2",
        //   },
        // },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        // {
        //   skillName: "Adobe Illustrator",
        //   fontAwesomeClassname: "simple-icons:adobeillustrator",
        //   style: {
        //     color: "#FF7C00",
        //   },
        // },
        // {
        //   skillName: "Inkscape",
        //   fontAwesomeClassname: "simple-icons:inkscape",
        //   style: {
        //     color: "#000000",
        //   },
        // },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/rahulkbhandari21",
    },
    {
      siteName: "LeeCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://leetcode.com/RKB2001/",
    },
    // {
    //   siteName: "GeeksForGeeks",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sharad Institute Of Technology College Of Engineering,Yadrav",
      subtitle: "B.Tech. in Computer Science Engineering",
      logo_path: "university_logo-removebg-preview.png",
      alt_name: "SITCOE",
      duration: "2020 - Present",
      descriptions: [
        "⚡ Studied foundational software engineering subjects including Data Structures, Algorithms, Database Management Systems, Operating Systems, Computer Networks, and Advanced Java Programming.",
        "⚡ In addition to this, I have completed courses in Data Science, Cloud Computing, and Web Development.",
        "⚡ Selected as the Event Head of a National Level Coding Event organized by the Compessa Committee of my college, where I successfully managed and attracted over 1500 participants.",
      ],
      website_link: "https://sitcoe.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Intel Computer Vision",
      subtitle: "- Bill Pearson",
      logo_path: "intel logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1x7R8k-XSuIZUTi3pRQeH0lt6DlIGkEYy/view?usp=sharing",
      alt_name: "Intel",
      color_code: "#1F70C199",
    },
    {
      title: "Google Cloud",
      subtitle: "- GC Hands-on Labs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1UTkQRl8fVKkmQbalitItj_3Rfbg4Ks_F/view?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Imperial College London",
      subtitle: "- Peter Childs",
      logo_path: "imperial clg.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1si7kkORXEfJzdNoiCOV48FVObhlvgBf7/view?usp=sharing",
      alt_name: "Google",
      color_code: "#1F70C199",
    },
    {
      title: "Google Virtual Machine",
      subtitle: "- Creating a Virtual Machine",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "Google",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have collaborated with numerous evolving startups as a trainee, developer, designer, and software architect. Additionally, I have interned with several well-established companies. My passion for organizing events has led me to take on various responsibilities in the past.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Contributions",
      experiences: [
        {
          title: "Developer",
          company: "Betseystakes",
          logo_path: "stakes.png",
          duration: "June 2024",
          location: "Australia Remote",
          description:
            "Betseystakes is an Australia-based company specializing in finance, markets, betting, and other software solutions.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "SDE Intern",
          company: "Krutrim",
          company_url: "https://olakrutrim.com/about-us/",
          logo_path: "krutrim-logo.jpg",
          duration: "Jan 2024 - Present",
          location: "Bangalore",
          description:
            "Experienced in both backend and frontend development for LLM products, with hands-on experience in Appium, Android, web scraping, Docker, Redis, and Grafana.",
          color: "#0071C5",
        },
        {
          title: "AI Intern",
          company: "Ola",
          company_url: "https://www.olacabs.com/",
          logo_path: "ola-logo.png",
          duration: "Nov 2023- Jan 2024",
          location: "Bangalore",
          description:
            "Developed automation bots for the DataOps team to autonomously collect responses, fine-tuned and deployed two open-source models on a VM, and explored various AI verticals.",
          color: "#0071C5",
        },
        {
          title: "Blockchain Intern",
          company: "DS Legends.",
          company_url: "https://dsl.sg/",
          logo_path: "ds-logo.png",
          duration: "July 2022- Aug 2022",
          location: "Work From Home",
          description:
            "Created a project of crypto token smart contract. There was objective To build a smart contract and a token [ERC20] and implementing concepts of solidability",
          color: "#0071C5",
        },
        {
          title: "Software Management Trainee",
          company: "GAO Tek",
          company_url: "https://gaotek.com/",
          logo_path: "gao-logo.png",
          duration: "Sept 2022 - Dec 2018",
          location: "Work From Home",
          description:
            "Here I got work experince with an Internationally reputable high tech company, the task was to manage business and tech related work, also i was promoted to Sub-Team lead during this internship",
          color: "#0071C5",
        },
        {
          title: " Web Developer Trainee",
          company: "XcitEduaction Worldwide",
          company_url: "https://www.xcitedu.com/",
          logo_path: "XcitEducation-logo.png",
          duration: "Feb 2018 - July 2018",
          location: "Work From Home",
          description:
            "Worked with a team on several projects from that major project was companys own Eduaction course selling Website, with integration of payment/sales and transaction. Also developed and designed own projects based on Front end technology",
          color: "#0071C5",
        },
        {
          title: "Digital Marketting & management",
          company: "IFORTIS Corporate",
          company_url: "https://ifortisworldwide.com/",
          logo_path: "IFORTIS-logo.jpeg",
          duration: "May 2021 - July 2021",
          location: "Work From Home",
          description:
            "Worked as Intern under guidance of Seniors and Juniors where the skills i covered were Marketing and Sales Trainee in Marketing Department besides this also committed to showing high comprehension capacity, with managing assignments with the utmost expertise and exhibiting maximal efficiency, and was recommended has also an outstanding professional demeanor excellent moral character throughout the internship period",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Alpha Student Ambassador",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/en-in",
          logo_path: "microsoft_logo.png",
          duration: "2021",
          location: "Virtual Community",
          description:
            "Helped students and formed communities, leading in local tech circles, and developed technical and career skills for the future",
          color: "#4285F4",
        },
        {
          title: "Mentor",
          company: "Team Everest",
          company_url: "https://www.teameverest.ngo/",
          logo_path: "teameverest-logo.png",
          duration: "Present",
          location: "Virtual",
          description:
            "Team Everest is a studnet welfare an open source community of teaching and volunteering program where educating 100000+ studnets , here different working profession people that may be mentors and professionals,freelancers contribute in both sense where I am contributing has a coding mentor taking sessions on a particular coding language or topic",
          color: "#4285F4",
        },
        // {
        //   title: "Mozilla Campus Captain",
        //   company: "Mozilla",
        //   company_url: "https://www.mozilla.org/",
        //   logo_path: "mozilla_logo.png",
        //   duration: "Oct 2019 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
        //   color: "#000000",
        // },
        // {
        //   title: "Developer Students Club Member",
        //   company: "DSC IIITDM Kurnool",
        //   company_url:
        //     "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
        //   logo_path: "dsc_logo.png",
        //   duration: "Jan 2018 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
        //   color: "#0C9D58",
        // },
        // {
        //   title: "Developer Program Member",
        //   company: "Github",
        //   company_url: "https://github.com/",
        //   logo_path: "github_logo.png",
        //   duration: "July 2019 - PRESENT",
        //   location: "Work From Home",
        //   description:
        //     "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
        //   color: "#181717",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a wide range of cutting-edge technologies, with a focus on Java-based and machine learning projects, which I deploy to web applications using diverse infrastructure solutions.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published several research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "rkb-logo.png",
    description:
      "I’m active on almost every social media platform. Feel free to message me, and I'll respond within 24 hours. I’m here to assist with software development and open-source projects.",
  },
  blogSection: {
    title: "Template Card",
    subtitle:
      "Customizable template card that showcases dynamic content and enhances user engagement",
    link: "https://rahul-profile-card.netlify.app/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Kolhapur, Maharashtra",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/rj2TDDqqpCb4E6BB6",
  },
  phoneSection: {
    title: "Email ID",
    subtitle: "rahulkbhandari272002@gmail.com",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
